module.exports = __webpack_public_path__ + "static/media/menu.250f2e1e.svg";